import { useState } from 'react';

const initials = (name: string) =>
  name.split(/\s+/).filter(Boolean).map((w) => w[0]).slice(0, 2).join('').toUpperCase() || '?';

/**
 * Profile picture with initials behind it.
 *
 * Google's avatar URLs 404 when someone removes their photo, and they are
 * blocked outright by some content blockers, so a broken image must degrade to
 * something readable rather than a torn-page icon.
 */
export default function Avatar({
  name, url, size = 26,
}: { name: string; url?: string | null; size?: number }) {
  const [failed, setFailed] = useState(false);
  const style = { width: size, height: size, fontSize: Math.round(size * 0.42) };

  if (!url || failed) {
    return <div className="avatar" style={style} aria-hidden="true">{initials(name)}</div>;
  }
  return (
    <img
      className="avatar" style={style} src={url} alt=""
      referrerPolicy="no-referrer" loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
